import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "status"]

  async useDeviceLocation(event) {
    event.preventDefault()

    if (!navigator.geolocation) {
      this.updateStatus("Geolocation is not supported by this browser.", true)
      return
    }

    this.updateStatus("Getting your coordinates...")

    navigator.geolocation.getCurrentPosition(
      async ({ coords }) => {
        this.updateStatus("Looking up your location...")

        try {
          const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
          const response = await fetch("/geocoders/reverse_geocode", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": csrfToken
            },
            body: JSON.stringify({
              latitude: coords.latitude,
              longitude: coords.longitude
            })
          })

          const data = await response.json()

          if (data.success && data.address) {
            this.locationTarget.value = data.address
            this.updateStatus("Location added from your device.")
          } else {
            this.locationTarget.value = `${coords.latitude}, ${coords.longitude}`
            this.updateStatus("Using raw coordinates because no address was found.")
          }
        } catch (error) {
          console.error("Nation geolocation error:", error)
          this.locationTarget.value = `${coords.latitude}, ${coords.longitude}`
          this.updateStatus("Using raw coordinates because lookup failed.")
        }
      },
      (error) => {
        this.updateStatus(`Location error: ${error.message}`, true)
      }
    )
  }

  updateStatus(message, isError = false) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.dataset.state = isError ? "error" : "ok"
  }
}
